<div class="container">
  <h1 class="page-title"><span class="icon"><i class="fas fa-money-bill-transfer"></i></span>{{ 'TariffRate.Header' | translate }}</h1>
  <p-card>
      <form class="detail-form" [formGroup]="editForm">
        <div class="field grid">
          <div class="p-fluid field grid">
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">貨代</label>
              <div class="col-8 column-value">
                {{ tariffRate?.forwarder | optionsMapping:forwarderOptions | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">料號</label>
              <div class="col-8 column-value">
                {{ tariffRate?.sku | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">關稅率</label>
              <div class="col-8 column-value">
                <p-inputNumber formControlName="tariffRate" [(ngModel)]="tariffRate.tariffRate " mode="decimal" [minFractionDigits]="3" [maxFractionDigits]="3"></p-inputNumber>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">海關稅號</label>
              <div class="col-8 column-value">
                <input type="text" pInputText formControlName="customsTariff" [(ngModel)]="tariffRate.customsTariff" />
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">料號描述</label>
              <div class="col-8 column-value">
                <input type="text" pInputText formControlName="skuDescription" [(ngModel)]="tariffRate.skuDescription" />
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">申報日期</label>
              <div class="col-8 column-value">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" formControlName="declarationDtTimeZone" [(ngModel)]="tariffRate.declarationDtTimeZone"></p-calendar>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">品牌</label>
              <div class="col-8 column-value">
                <input type="text" pInputText formControlName="brand" [(ngModel)]="tariffRate.brand" />
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">是否有效</label>
              <div class="col-8 column-value">
                <p-radioButton formControlName="isActivated" name="isActivated" value="1" label="Y" [(ngModel)]="tariffRate.isActivated"></p-radioButton>
                <p-radioButton formControlName="isActivated" name="isActivated" value="0" label="N" [(ngModel)]="tariffRate.isActivated" class="ml-2"></p-radioButton>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">起始日</label>
              <div class="col-8 column-value">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" formControlName="startDtTimeZone" [(ngModel)]="tariffRate.startDtTimeZone"></p-calendar>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">結束日</label>
              <div class="col-8 column-value">
                <p-calendar dataType="string" dateFormat="yy/mm/dd" formControlName="endDtTimeZone" [(ngModel)]="tariffRate.endDtTimeZone"></p-calendar>
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">建立者</label>
              <div class="col-8 column-value">
                {{ tariffRate?.createUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">建立時間</label>
              <div class="col-8 column-value">
                {{ tariffRate?.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">更新者</label>
              <div class="col-8 column-value">
                {{ tariffRate?.updateUser | replaceNullWith:'-' }}
              </div>
            </div>
            <div class="field grid col-6 align-items-baseline">
              <label class="col-4 column-label">更新時間</label>
              <div class="col-8 column-value">
                {{ tariffRate?.updateDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtnClick($event)" class="mr-2"></button>
              <button pButton pRipple label="{{ 'Common.Button.ReturnWithoutSaving' | translate }}" (click)="goToLastPage()" class="mr-2"></button>
            </div>
          </div>
        </div>
      </form>
  </p-card>
</div>
